import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";

import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select, Tooltip,
} from '@mui/material';
import TablePage from "../../global/Table/TablePage";
import {
    DEFAULT_SORT_BY_LEDGER_NAME_CELL,
    LEDGER_TABLE_CELLS,
    LEDGERS,
    LEDGERS_PAGES,
    MARKETPLACE_MAPPING
} from './constants';
import {IconButton, Tab} from "@material-ui/core";
import './ledger.css';
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import LedgerTableRow from "./LedgerTableRow";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import AssessmentIcon from "@material-ui/icons/Assessment";
import * as XLSX from 'xlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SyncIcon from '@mui/icons-material/Sync';
import { HourglassEmptyTwoTone } from '@material-ui/icons';

class LedgerTable extends React.Component {
    constructor(props) {
        super(props)
        const savedTab = localStorage.getItem('selectedTab') || "1";
        this.state = {
            deleteId: "",
            isDeleted: false,
            listingIdBeingEdited: '',
            tableEvents: [],
            isEdit: false,
            ledgers: [],
            hideFilterBox : false,
            value: savedTab,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.ledgers !== this.props.ledgers) {
            this.setState({ledgers:this.props.ledgers})
        }
    }

    componentDidMount() {
        this.props.listLedgers({currency: this.props.selectedCurrency, year: this.props.selectedYear})
        const savedTab = localStorage.getItem('selectedTab') || "1";
        this.setState({ value: savedTab },()=>{
            this.props.handleLedgerType(savedTab)
        });
    }


    handleTabChange = (event, newValue) => {
        this.setState({ value: newValue },()=>{
            localStorage.setItem('selectedTab', newValue);
            this.props.handleLedgerType(newValue)
        });

    };

    setLedgers = (ledgers) => {
        this.setState({ledgers: ledgers})
    }

    handleExport = () => {
        const { exportAllLedgers, ledgerType } = this.props;
        const workbook = XLSX.utils.book_new();
        const formatAmount = (amount) => {
            const num = parseFloat(amount);
            return isNaN(num) || num === 0 ? '' : Number(num.toFixed(2))
        };

        const addSheet = (sheetName, headers, data) => {
            const MAX_SHEET_NAME_LENGTH = 31
            const truncatedSheetName = sheetName.substring(0, MAX_SHEET_NAME_LENGTH)

            if (headers) {
                const worksheetData = [headers, ...data.map(row => headers.map(field => row[field] ?? ''))]
                const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
                XLSX.utils.book_append_sheet(workbook, worksheet, truncatedSheetName)
            } else {
                const worksheetData = [headers, ...data.map(row => ["name", "amount"].map(field => row[field] ?? ''))]
                const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
                XLSX.utils.book_append_sheet(workbook, worksheet, truncatedSheetName)
            }
        }

        if (!exportAllLedgers) return;

        // Iterate over each ledger in exportAllLedgers
        Object.keys(exportAllLedgers).forEach(ledgerName => {
            const ledgerData = exportAllLedgers[ledgerName];

            // Special case for "Sales"
            if (ledgerName === "Sales") {
                const { salesSummary, customerSummary, ledgerEntries } = ledgerData;
                const totalSales = (salesSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalCustomer = (customerSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalLedgerEntries = (ledgerEntries || []).filter(entry => entry.description !== "Sales").reduce((sum, entry) => sum + parseFloat(entry.credit), 0);

                // Combine all data into a single array
                const combinedData = [
                    {  name: "Sales" ,
                        amount: "Amount"
                    },
                    ...(salesSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: MARKETPLACE_MAPPING[row.name],
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalSales)
                    },
                    // Add an empty line after sales summary
                    {},
                    {  name: "Customer" ,
                        amount: "Amount"
                    },
                    ...(customerSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: row.name,
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalCustomer)
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Other" ,
                        amount: "Amount"
                    },
                    ...(ledgerEntries || []).filter(entry => entry.description !== "Sales").map(entry => ({
                        name: entry.description,
                        amount: formatAmount(entry.credit)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalLedgerEntries)
                    },
                    // Add an empty line after ledger entries
                    {},
                ];



                // Combine all totals into one final total row
                const grandTotal = (totalSales + totalCustomer + totalLedgerEntries).toFixed(2);

                // Add the grand total row
                combinedData.push({
                    name: "Sales Total",
                    amount: formatAmount(grandTotal)
                });

                // Define headers
                const headers = null

                // Add the combined data to a single sheet
                addSheet('Sales', headers, combinedData);
            }
            else if (ledgerName === "Cash") {
                const { ledgerEntries,bankAccountSummary, outstandingChequesSummary  } = ledgerData;

                const totalOutstandingCheques = (outstandingChequesSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);

                const totalBankAccounts = (bankAccountSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalLedgerEntries = (ledgerEntries || []).filter(entry => entry.description !== "Cash").reduce((sum, entry) => sum + parseFloat(entry.credit), 0);


                // Combine all data into a single array
                const combinedData = [
                    {  name: "Bank Balances" ,
                        amount: "Amount"
                    },
                    ...(bankAccountSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: row.name,
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalBankAccounts)
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Outstanding Cheques" ,
                        amount: "Amount"
                    },
                    ...(outstandingChequesSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: row.name,
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalOutstandingCheques)
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Other" ,
                        amount: "Amount"
                    },
                    ...(ledgerEntries || []).filter(entry => entry.description !== "Cash").map(entry => ({
                        name: entry.description,
                        amount: formatAmount(entry.credit)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalLedgerEntries)
                    },
                    // Add an empty line after ledger entries
                    {},
                ];



                // Combine all totals into one final total row
                const grandTotal = (totalBankAccounts + totalOutstandingCheques + totalLedgerEntries).toFixed(2);

                // Add the grand total row
                combinedData.push({
                    name: "Cash Total",
                    amount: formatAmount(grandTotal)
                });

                // Define headers
                const headers = null

                // Add the combined data to a single sheet
                addSheet('Cash', headers, combinedData);
            }
            else if (ledgerName === "Accounts Receivables") {
                const { marketplaceSummary, customerSummary, ledgerEntries } = ledgerData;

                const totalMarketplace = (marketplaceSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalCustomer = (customerSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalLedgerEntries = (ledgerEntries || []).filter(entry => entry.description !== "Accounts Receivables").reduce((sum, entry) => sum + parseFloat(entry.credit), 0);


                // Combine all data into a single array
                const combinedData = [
                    {  name: "Marketplace" ,
                        amount: "Amount"
                    },
                    ...(marketplaceSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: MARKETPLACE_MAPPING[row.name],
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalMarketplace)
                    },
                    // Add an empty line after sales summary
                    {},
                    {  name: "Customer" ,
                        amount: "Amount"
                    },
                    ...(customerSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: row.name,
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalCustomer)
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Other" ,
                        amount: "Amount"
                    },
                    ...(ledgerEntries || []).filter(entry => entry.description !== "Accounts Receivables").map(entry => ({
                        name: entry.description,
                        amount: formatAmount(entry.credit)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalLedgerEntries)
                    },
                    // Add an empty line after ledger entries
                    {},
                ];



                // Combine all totals into one final total row
                const grandTotal = (totalMarketplace + totalCustomer + totalLedgerEntries).toFixed(2);

                // Add the grand total row
                combinedData.push({
                    name: "Accounts Receivables Total",
                    amount: formatAmount(grandTotal)
                });

                // Define headers
                const headers = null

                // Add the combined data to a single sheet
                addSheet('Accounts Receivables', headers, combinedData);
            }
            else if (ledgerName === "Accounts Payable") {
                const { carrierSummary, ftlSummary, supplierSummary, ledgerEntries, creditCardBalancesSummary } = ledgerData;




                const totalCreditCardBalances = (creditCardBalancesSummary || []).filter(entry => entry.name !== "Total").reduce((sum, row) => sum + parseFloat(row.totalBalance), 0);
                const totalCarrier = (carrierSummary || []).filter(entry => entry.carrierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalFTL= (ftlSummary || []).filter(entry => entry.carrierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalSupplier = (supplierSummary || []).filter(entry => entry.supplierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalLedgerEntries = (ledgerEntries || []).filter(entry => entry.description !== "Accounts Payable").reduce((sum, entry) => sum + parseFloat(entry.credit), 0);


                // Combine all data into a single array
                const combinedData = [
                    {  name: "Credit Card Balances" ,
                        amount: "Amount"
                    },
                    ...(creditCardBalancesSummary || []).filter(row => row.name !== "Total").map(row => ({
                        name: row.name,
                        amount: formatAmount(row.totalBalance)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalCreditCardBalances)
                    },
                    // Add an empty line after sales summary
                    {},

                    {  name: "Standard Carrier" ,
                        amount: "Amount"
                    },
                    ...(carrierSummary || []).filter(row => row.carrierName !== "Total").map(row => ({
                        name: row.carrierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalCarrier)
                    },
                    // Add an empty line after sales summary
                    {},
                    {  name: "LTL/FTL Carrier" ,
                        amount: "Amount"
                    },
                    ...(ftlSummary || []).filter(row => row.carrierName !== "Total").map(row => ({
                        name: row.carrierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalFTL)
                    },
                    // Add an empty line after customer summary
                    {},
                    {  name: "Supplier" ,
                        amount: "Amount"
                    },
                    ...(supplierSummary || []).filter(row => row.supplierName !== "Total").map(row => ({
                        name: row.supplierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalSupplier)
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Other" ,
                        amount: "Amount"
                    },
                    ...(ledgerEntries || []).filter(entry => entry.description !== "Accounts Payable").map(entry => ({
                        name: entry.description,
                        amount: formatAmount(entry.credit)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalLedgerEntries)
                    },
                    // Add an empty line after ledger entries
                    {},
                ];



                // Combine all totals into one final total row
                const grandTotal = ( totalCreditCardBalances + totalCarrier + totalFTL + totalSupplier + totalLedgerEntries).toFixed(2);

                // Add the grand total row
                combinedData.push({
                    name: "Accounts Payable Total",
                    amount: formatAmount(grandTotal)
                });

                // Define headers
                const headers = null

                // Add the combined data to a single sheet
                addSheet('Accounts Payable', headers, combinedData);
            }
            else if (ledgerName === "Cost of Sales") {
                const { stockSummary,carrierSummary, ftlSummary, supplierSummary, ledgerEntries } = ledgerData;

                const totalStock = (stockSummary || []).reduce((sum, row) => sum + parseFloat(row.balance), 0);
                const totalCarrier = (carrierSummary || []).filter(entry => entry.carrierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalFTL= (ftlSummary || []).filter(entry => entry.carrierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalSupplier = (supplierSummary || []).filter(entry => entry.supplierName !== "Total").reduce((sum, row) => sum + parseFloat(row.CY_SUBTOTAL_PAYABLE), 0);
                const totalLedgerEntries = (ledgerEntries || []).filter(entry => entry.description !== "Cost of Sales").reduce((sum, entry) => sum + parseFloat(entry.credit), 0);



                // Combine all data into a single array
                const combinedData = [
                    {  name: "Stock" ,
                        amount: "Amount"
                    },
                    ...(stockSummary || []).map(row => ({
                        name: row.name,
                        amount: formatAmount(row.balance)
                    })),
                    {},
                    {  name: "Standard Carrier" ,
                        amount: "Amount"
                    },
                    ...(carrierSummary || []).filter(row => row.carrierName !== "Total").map(row => ({
                        name: row.carrierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalCarrier)
                    },
                    // Add an empty line after sales summary
                    {},
                    {  name: "LTL/FTL Carrier" ,
                        amount: "Amount"
                    },
                    ...(ftlSummary || []).filter(row => row.carrierName !== "Total").map(row => ({
                        name: row.carrierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalFTL)
                    },
                    // Add an empty line after customer summary
                    {},
                    {  name: "Supplier" ,
                        amount: "Amount"
                    },
                    ...(supplierSummary || []).filter(row => row.supplierName !== "Total").map(row => ({
                        name: row.supplierName,
                        amount: formatAmount(row.CY_SUBTOTAL_PAYABLE)
                    })),
                    {  name: "Total" ,
                        amount: totalSupplier
                    },
                    // Add an empty line after customer summary
                    {},

                    {  name: "Other" ,
                        amount: "Amount"
                    },
                    ...(ledgerEntries || []).filter(entry => entry.description !== "Cost of Sales").map(entry => ({
                        name: entry.description,
                        amount: formatAmount(entry.credit)
                    })),
                    {  name: "Total" ,
                        amount: formatAmount(totalLedgerEntries)
                    },
                    // Add an empty line after ledger entries
                    {},
                ];



                // Combine all totals into one final total row
                const grandTotal = ( totalStock + totalCarrier + totalFTL + totalSupplier + totalLedgerEntries).toFixed(2);

                // Add the grand total row
                combinedData.push({
                    name: "Cost of Sales Total",
                    amount: formatAmount(grandTotal)
                });

                // Define headers
                const headers = null

                // Add the combined data to a single sheet
                addSheet('Cost of Sales', headers, combinedData);
            }
            // Handle other ledger types
            else {
                const ledgerEntries = ledgerData.ledgerEntries || [];

                const headers = ["date", "description", "debit", "credit", "balance"]

                const data = [
                    ...ledgerEntries.map(entry => ({
                        date: entry.date,
                        description: entry.description,
                        debit: formatAmount(entry.debit),
                        credit: formatAmount(entry.credit),
                        balance: formatAmount(entry.balance)
                    })),
                ]
                addSheet(ledgerName, headers, data);
            }
        });

        // Export and download the file
        XLSX.writeFile(workbook, `${ledgerType}_${this.props.selectedYear}_${this.props.selectedCurrency}_Ledger.xlsx`);
    };

    getContextualMenuItems = () => {
        const menuItems = [];
        // "Consolidated CAD" is a view-only currency; a ledger entry can't be stored against
        // it, so hide Add Ledger while that filter is active (pick CAD or USD to add).
        if (this.props.selectedCurrency !== 'Consolidated CAD') {
            menuItems.push(
              {
                  title: 'Add Ledger',
                  icon: <AddCircleIcon />,
                  onClick: () => {
                      this.props.setCurrentPage(LEDGERS_PAGES.FORM, {value: this.state.value})
                  },
              }
             );
        }

        if (this.props.exportAllLedgers) {
            menuItems.push({
                title: 'Download as CSV',
                icon: <FileDownloadIcon />,
                onClick: () => {
                    this.handleExport();
                }
            });
        }

        menuItems.push({
            title: 'Ledger Audit',
            icon: <AssessmentIcon />,
            onClick: () => {
                this.props.setCurrentPage(LEDGERS_PAGES.AUDIT, {})
            }
        });

        if (this.props.loadingData) {
            menuItems.push({
                title: 'Checking for updates…',
                icon: <HourglassEmptyTwoTone />,
                onClick: () => null,
                disabled: true,
            });
        } else if (this.props.onCheckForUpdates) {
            menuItems.push({
                title: 'Check for updates',
                icon: <SyncIcon />,
                onClick: () => {
                    this.props.onCheckForUpdates();
                }
            });
        }


        return menuItems.filter(Boolean);  // Ensure no `undefined` or `null` values
    };



    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null,null,null))
        LEDGER_TABLE_CELLS.forEach((headCell, index) => {
            const alignment = index === LEDGER_TABLE_CELLS.length - 1 ? "left" : "left"
            headers.push(Layout.columnHead(headCell.label, headCell.id, alignment))
        })
        return headers
    }


    getTableRow = (row, getRowState, setRowState,ledgerType) => {
        return<LedgerTableRow
            row={row}
            categories={this.props.categories}
            isEdit={this.state.isEdit}
            allLedgers={this.state.ledgers}
            setLedgers={this.setLedgers}
            getRowState={getRowState}
            setRowState={setRowState}
            setCurrentPage={this.props.setCurrentPage}
            listingIdBeingEdited={this.state.listingIdBeingEdited}
            setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
            deleteLedgerByYearAndCurrency={this.props.deleteLedgerByYearAndCurrency}
            updateLedger={this.props.updateLedger}
            deleteLedger={this.props.deleteLedger}
            year={this.props.selectedYear}
            currency={this.props.selectedCurrency}
            ledgerType={ledgerType}
            setHideFilterBox={this.setHideFilterBox}
            settings={this.props.settings}
            isDesynced={this.props.desyncMap?.[row.ledgerId]}
        />
    }

    setHideFilterBox = (isHide) =>{
        this.setState({hideFilterBox : isHide})
    }


    getBalanceForSelectedYear = (row, ledgerType) => {
        const { selectedYear, selectedCurrency, settings } = this.props;

        const yearRate = parseFloat(
          settings?.yearRates?.find(s => s.year === selectedYear.toString())?.rate
        ) || 0;

        const averageRate = parseFloat(
          settings?.averageRates?.find(s => s.year === selectedYear.toString())?.rate
        ) || 0;

        const applicableRate = ['Equity', 'Assets', 'Liabilities'].includes(ledgerType)
          ? yearRate
          : ['Expenses', 'Income'].includes(ledgerType)
            ? averageRate
            : 1;

        const entries = row?.ledgerEntries?.filter(e => e?.year === selectedYear) || [];

        const flattenEntries = entries.flatMap(e => e.entries || []);

        const toNumber = (val) => typeof val === 'string' ? parseFloat(val) : (val || 0);

        if (['Accounts Payable', 'Cost of Sales', 'Sales'].includes(row?.name)) {
            let credits = 0;

            flattenEntries.forEach(entry => {
                if (selectedCurrency === 'CAD' && entry.currency === 'CAD') {
                    credits += toNumber(entry.credit);
                } else if (selectedCurrency === 'USD' && entry.currency === 'USD') {
                    credits += toNumber(entry.credit);
                } else if (selectedCurrency === 'Consolidated CAD') {
                    if (entry.currency === 'CAD') {
                        credits += toNumber(entry.credit);
                    } else if (entry.currency === 'USD') {
                        const converted = toNumber(entry.credit) * applicableRate;
                        credits += converted;
                    }
                }
            });

            return credits;
        }

        if (row?.name === 'Accounts Receivables' || row?.name === 'Cash') {
            let total = 0;

            flattenEntries.forEach(entry => {
                if (selectedCurrency === 'CAD' && entry.currency === 'CAD') {
                    total += toNumber(entry.debit) + toNumber(entry.credit);
                } else if (selectedCurrency === 'USD' && entry.currency === 'USD') {
                    total += toNumber(entry.debit) + toNumber(entry.credit);
                } else if (selectedCurrency === 'Consolidated CAD') {
                    if (entry.currency === 'CAD') {
                        total += toNumber(entry.debit) + toNumber(entry.credit);
                    } else if (entry.currency === 'USD') {
                        const converted = (toNumber(entry.debit) + toNumber(entry.credit)) * applicableRate;
                        total += converted;
                    }
                }
            });

            return total;
        }

        if (selectedCurrency === 'Consolidated CAD') {
            const cad = entries?.find(e => e.year === selectedYear && e.currency === 'CAD');
            const usd = entries.find(e => e.year === selectedYear && e.currency === 'USD');

            const cadBalance = toNumber(cad?.balance ?? 0);
            const usdBalance = toNumber(usd?.balance ?? 0);
            return cadBalance + usdBalance;
        }else {
            const entry = row?.ledgerEntries?.find(
              e => e.year === selectedYear && e.currency === selectedCurrency
            );
            return toNumber(entry?.balance);
        }
    }

    renderTablePanel = (ledgerType) => {
        const filteredLedgers = this.state.ledgers.filter((ledger) => ledger.type === ledgerType);

        const totalBalance = filteredLedgers.reduce((sum, ledger) => {
                if (ledger.isShowTrialBalance) {
                    return sum + this.getBalanceForSelectedYear(ledger, ledgerType);
                }
                return sum;
        }, 0);

        let tableRows = [...filteredLedgers];
        if (filteredLedgers.length > 0 && totalBalance != null && totalBalance !== '') {
            const totalRow = {
                id: "total-row",
                name: "Total",
                balance: totalBalance,
                type: ledgerType,
            };
            tableRows.push(totalRow);
        }

        return (
            <div style={{ marginTop: "-80px", marginLeft: "-24px", marginRight: "-24px" }}>
                <TablePage
                    type={"ledgerTable"}
                    tableName="ledgerTable"
                    tableColumnHeads={this.getTableHeaders()}
                    tableRows={tableRows}
                    tableRow={(row, index, getRowState, setRowState) =>
                        this.getTableRow(row, getRowState, setRowState,ledgerType)
                    }
                    getRowId={(row) => row.ledgerId}
                    paginationText="Ledgers per page"
                    defaultSortBy={DEFAULT_SORT_BY_LEDGER_NAME_CELL}
                />
                {this.state.isEdit && this.props.selectedCurrency !== 'Consolidated CAD' && (
                    <Tooltip title="Add Ledger" style={{marginLeft:'16px',marginTop:'8px'}}>
                        <IconButton onClick={() => {
                            this.setState({listingIdBeingEdited: ""},()=>{
                                const newLedgers = [
                                    ...this.state.ledgers,
                                    {
                                        ledgerId: '',
                                        name: '',
                                        sumRule: '',
                                        carryForwardBalance: '',
                                        source: '',
                                        balance: 0,
                                        type: ledgerType
                                    }
                                ];
                                this.setState({ ledgers: newLedgers })
                            })
                        }
                        }
                               >
                            <AddCircleIcon
                                fontSize="small"
                                color='secondary'
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        );
    };


    render() {
        return (
            <React.Fragment>
                <TopToolbar
                    pageName={LEDGERS}
                    menuItems={this.getContextualMenuItems()}
                />

                    <Box className="box-ledger"   style={{ visibility: this.state.hideFilterBox ? 'hidden' : 'visible' }}>
                        <FormControl variant="outlined" className="form-control-ledger">
                            <InputLabel id="year-label">Year</InputLabel>
                            <Select
                                className="select-year-ledger"
                                labelId="year-label"
                                value={this.props.selectedYear}
                                onChange={this.props.handleYearChange}
                                label="Year"
                            >
                                {this.props.years.map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl variant="outlined" className="form-control">
                            <InputLabel id="currency-label">Currency</InputLabel>
                            <Select
                                className="select-currency-ledger"
                                labelId="currency-label"
                                value={this.props.selectedCurrency}
                                onChange={this.props.handleChange}
                                label="Currency"
                            >
                                {this.props.currency.map((currency) => (
                                    <MenuItem key={currency} value={currency}>
                                        {currency}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>



                {/* Tab Context */}
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={this.state.value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={this.handleTabChange} aria-label="ledger tabs">
                                <Tab label="Assets" value="1" />
                                <Tab label="Liabilities" value="2" />
                                <Tab label="Income" value="3" />
                                <Tab label="Expenses " value="4" />
                                <Tab label="Equity" value="5" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">{this.renderTablePanel("Assets")}</TabPanel>
                        <TabPanel value="2">{this.renderTablePanel("Liabilities")}</TabPanel>
                        <TabPanel value="3">{this.renderTablePanel("Income")}</TabPanel>
                        <TabPanel value="4">{this.renderTablePanel("Expenses")}</TabPanel>
                        <TabPanel value="5">{this.renderTablePanel("Equity")}</TabPanel>
                    </TabContext>
                </Box>


            </React.Fragment>
        )
    }
}

export default LedgerTable;
